import type { FeatureManifest, FeatureRoute } from './types'

export interface FeatureRegistry {
  features: FeatureManifest[]
  routes: (FeatureRoute & { featureId: string })[]
  has: (featureId: string) => boolean
}

export function buildRegistry(manifests: FeatureManifest[]): FeatureRegistry {
  const ids = new Set<string>()
  const paths = new Set<string>()
  const routes: FeatureRegistry['routes'] = []
  for (const manifest of manifests) {
    if (ids.has(manifest.id)) throw new Error(`Feature duplicada: ${manifest.id}`)
    ids.add(manifest.id)
    for (const route of manifest.routes) {
      if (paths.has(route.path)) throw new Error(`Rota duplicada: ${route.path} (${manifest.id})`)
      paths.add(route.path)
      routes.push({ ...route, featureId: manifest.id })
    }
  }
  return { features: manifests, routes, has: (featureId) => ids.has(featureId) }
}

// Descoberta automática: qualquer src/features/**/feature.ts(x) que exporte `feature`.
const modules = import.meta.glob<{ feature?: FeatureManifest }>(
  '/src/features/**/feature.{ts,tsx}',
  { eager: true },
)

export const featureRegistry = buildRegistry(
  Object.values(modules)
    .map((module) => module.feature)
    .filter((feature): feature is FeatureManifest => Boolean(feature)),
)
